import { type JSX } from 'react';
import type { PropertyDescriptor } from '../../../core/definitions';
import { NumberField } from '../../components/NumberField';
import { coerceDuration, joinDuration, splitDuration, type DurationParts } from './coerce';

type DurationDescriptor = Extract<PropertyDescriptor, { type: 'duration' }>;

/**
 * A length of time stored as whole milliseconds and edited as hours, minutes
 * and seconds. Each part applies when it is left or Enter is pressed, so a
 * running countdown is not reset on every keystroke.
 */
export function DurationField(props: {
  desc: DurationDescriptor;
  value: number;
  id: string;
  onChange(value: number): void;
  onCommit(): void;
}): JSX.Element {
  const { desc, value, id, onChange, onCommit } = props;
  const parts = splitDuration(value);
  const set = (patch: Partial<DurationParts>): void => {
    const next = coerceDuration(joinDuration({ ...parts, ...patch }), desc);
    if (next !== value) onChange(next);
  };
  return (
    <div className="ui-row property-duration" role="group" aria-label={desc.label}>
      <NumberField id={id} label={`${desc.label} hours`} value={parts.hours} min={0} step={1} precision={0} unit="h" applyOn="commit" onChange={(hours) => set({ hours: Math.floor(hours) })} onCommit={onCommit} />
      <NumberField label={`${desc.label} minutes`} value={parts.minutes} min={0} step={1} precision={0} unit="min" applyOn="commit" onChange={(minutes) => set({ minutes: Math.floor(minutes) })} onCommit={onCommit} />
      <NumberField label={`${desc.label} seconds`} value={parts.seconds} min={0} step={1} precision={3} unit="s" applyOn="commit" onChange={(seconds) => set({ seconds })} onCommit={onCommit} />
    </div>
  );
}
